import { useMemo } from 'react';
import { keyBy } from 'lodash-es';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { getHomePagePages } from '~/utils/routeConfigs';
export function useHomePageRoutesByUrl() {
    const featureFlags = useFeatureFlags();
    return useMemo(()=>keyBy(getHomePagePages(featureFlags), 'url'), [
        featureFlags
    ]);
}
